import React, { useMemo, useState, useEffect } from "react";
import { Modal, Button, Radio, Select, Input } from "antd";
import moment from "moment";

const { Option } = Select;

const ChooseBasketModal = ({
  show,
  onClose,
  existingBaskets = [],
  defaultNewName = "",
  onConfirm,
  showSingleLegOption = false,
}) => {
  const hasExisting = (existingBaskets || []).length > 0;
  const [mode, setMode] = useState(hasExisting ? "existing" : "new");
  const [selectedExistingId, setSelectedExistingId] = useState(
    hasExisting ? existingBaskets[0]?.id : ""
  );
  const [newName, setNewName] = useState(defaultNewName || "");


  useEffect(() => {
    if (show) {
      const has = (existingBaskets || []).length > 0;
      setMode(has ? "existing" : "new");
      setSelectedExistingId(has ? existingBaskets[0]?.id : "");
      if (defaultNewName) {
        setNewName(`${defaultNewName} ${moment().format("HH:mm:ss")}`);
      } else {
        setNewName("");
      }
    }
  }, [show, existingBaskets, defaultNewName]);

  const canContinue = useMemo(() => {
    if (mode === "existing") return !!selectedExistingId;
    if (mode === "singleLeg") return true;
    return (newName || "").trim().length > 0;
  }, [mode, selectedExistingId, newName]);

  const handleConfirm = () => {
    if (!canContinue) return;
    if (mode === "existing") {
      const chosen = (existingBaskets || []).find(b => b.id === selectedExistingId);
      onConfirm && onConfirm({ mode: "existing", basketId: chosen?.id || "", basketName: chosen?.name || "" });
    } else {
      if (mode === "singleLeg") {
        onConfirm && onConfirm({ mode: "singleLeg", basketId: "", basketName: "" });
      } else {
        onConfirm && onConfirm({ mode: "new", basketId: "", basketName: (newName || "").trim() });
      }
    }
  };

  return (
    <Modal
      title="Modify or Create New Strategy"
      open={show}
      onCancel={onClose}
      centered
      className="add-strategy"
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="continue"
          type="primary"
          onClick={handleConfirm}
          disabled={!canContinue}
        >
          Continue
        </Button>
      ]}
    >
      <div className="pt-3">
        {hasExisting && (
          <div
            className={`basket-strategy-option ${mode === "existing" ? "active" : ""}`}
          >
            <Radio
              checked={mode === "existing"}
              onChange={() => setMode("existing")}
              className="strategy-radio-label"
            >
              Add to existing strategy
            </Radio>
            {mode === "existing" && (
              <Select
                value={selectedExistingId}
                onChange={(val) => setSelectedExistingId(val)}
                className="strategy-select-dropdown"
              >
                {existingBaskets.map((b) => {
                  const label = (b?.name && b.name.trim().length > 0) ? b.name : "(Unnamed)";
                  return (
                    <Option value={b?.id} key={b?.id || "__unnamed__"}>
                      {label}
                    </Option>
                  );
                })}
              </Select>
            )}
          </div>
        )}

        <div
          className={`basket-strategy-option ${mode === "new" ? "active" : ""}`}
        >
          <Radio
            checked={mode === "new"}
            onChange={() => setMode("new")}
            className="strategy-radio-label"
          >
            Create new strategy
          </Radio>
          {mode === "new" && (
            <Input
              placeholder="Enter strategy name"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              className="strategy-name-input"
            />
          )}
        </div>

        {showSingleLegOption && (
          <div
            className={`basket-strategy-option last ${mode === "singleLeg" ? "active" : ""}`}
          >
            <Radio
              checked={mode === "singleLeg"}
              onChange={() => setMode("singleLeg")}
              className="strategy-radio-label"
            >
              Add to single leg strategies
            </Radio>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ChooseBasketModal;


